__turbopack_context__.v({
  "badge": "Badge-module-scss-module__dan1QW__badge",
  "fade-in": "Badge-module-scss-module__dan1QW__fade-in",
  "no-transform": "Badge-module-scss-module__dan1QW__no-transform",
  "rotate": "Badge-module-scss-module__dan1QW__rotate",
  "sizeLarge": "Badge-module-scss-module__dan1QW__sizeLarge",
  "sizeMedium": "Badge-module-scss-module__dan1QW__sizeMedium",
  "sizeSmall": "Badge-module-scss-module__dan1QW__sizeSmall",
  "toneBrand": "Badge-module-scss-module__dan1QW__toneBrand",
  "toneBrandSecondary": "Badge-module-scss-module__dan1QW__toneBrandSecondary",
  "toneCaution": "Badge-module-scss-module__dan1QW__toneCaution",
  "toneCritical": "Badge-module-scss-module__dan1QW__toneCritical",
  "toneDefault": "Badge-module-scss-module__dan1QW__toneDefault",
  "toneFill": "Badge-module-scss-module__dan1QW__toneFill",
  "toneFillSecondary": "Badge-module-scss-module__dan1QW__toneFillSecondary",
  "toneFillTertiary": "Badge-module-scss-module__dan1QW__toneFillTertiary",
  "toneInfo": "Badge-module-scss-module__dan1QW__toneInfo",
  "toneSuccess": "Badge-module-scss-module__dan1QW__toneSuccess",
});
